/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Conversations_Open_UnreadInputs */

const en_us2_coach_extra_conversations_open_unread = /** @type {(inputs: Coach_Extra_Conversations_Open_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations, with an unread answer`)
};

const pt_br2_coach_extra_conversations_open_unread = /** @type {(inputs: Coach_Extra_Conversations_Open_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversas, com resposta não lida`)
};

const es_419_coach_extra_conversations_open_unread = /** @type {(inputs: Coach_Extra_Conversations_Open_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversaciones, con una respuesta sin leer`)
};

const pt_pt2_coach_extra_conversations_open_unread = /** @type {(inputs: Coach_Extra_Conversations_Open_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversas, com resposta não lida`)
};

const fr_fr2_coach_extra_conversations_open_unread = /** @type {(inputs: Coach_Extra_Conversations_Open_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations, avec une réponse non lue`)
};

const de_de2_coach_extra_conversations_open_unread = /** @type {(inputs: Coach_Extra_Conversations_Open_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltungen, mit ungelesener Antwort`)
};

const it_it2_coach_extra_conversations_open_unread = /** @type {(inputs: Coach_Extra_Conversations_Open_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversazioni, con una risposta non letta`)
};

/**
* | output |
* | --- |
* | "Conversations, with an unread answer" |
*
* @param {Coach_Extra_Conversations_Open_UnreadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_conversations_open_unread = /** @type {((inputs?: Coach_Extra_Conversations_Open_UnreadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Conversations_Open_UnreadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_conversations_open_unread(inputs)
	if (locale === "es-419") return es_419_coach_extra_conversations_open_unread(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_conversations_open_unread(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_conversations_open_unread(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_conversations_open_unread(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_conversations_open_unread(inputs)
	return en_us2_coach_extra_conversations_open_unread(inputs)
});
export { coach_extra_conversations_open_unread as "coach-extra.conversations_open_unread" }